import React from 'react';
import {Input} from '../UI';
import {MaskedInput} from '../UI/MaskedInput';

export const GeneralInfo = () => {
  return (
    <div className='space-y-4'>
      <div className='grid grid-cols-3 gap-6'>
        <Input name='name' label='Applicant Name' />
        <MaskedInput name='ssn' label='Social Security Number' mask='999-99-9999' />
        <MaskedInput name='birthdate' label='Date of Birth' mask='99/99/9999' />
      </div>
      <div className='grid grid-cols-2 gap-6'>
        <MaskedInput name='phone' label='Phone Number' mask='(999) 999-9999' />
        <Input name='email' label='E-mail' />
      </div>
      <div className='grid grid-cols-2 gap-6'>
        <Input name='currentAddress' label='Current Address' />
        <Input name='previousAddress' label='Previous Address' />
      </div>
    </div>
  );
};